import * as ActionTypes from 'actions/partnerHierarchyForm'

const initialState = {
  isFetching: false,
  selectedPartner: {},
}

export default function mdm(state = initialState, action) {
  switch (action.type) {
    case ActionTypes.PARTNER_HIERARCHY_GETING_PARTNER_HIERARCHY:
      return Object.assign({}, state, {
        isFetching: true,
      })
    case ActionTypes.PARTNER_HIERARCHY_RECEIVED_PARTNER_HIERARCHY:
      return {
        ...state,
        isFetching: false,
        selectedPartner: action.partner,
      }

    case ActionTypes.PARTNER_HIERARCHY_SAVE_PARTNER_HIERARCHY_START:
      return Object.assign({}, state, {
        isFetching: true,
      })
    case ActionTypes.PARTNER_HIERARCHY_SAVE_PARTNER_HIERARCHY_COMPLETE:
      return {
        ...state,
        isFetching: false,
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/partnerHierarchy.js